import {
  CorrectionExecutionRequest,
  CorrectionPreview,
  MetadataCorrectionWorkspace,
  ProblematicMetadataRow
} from '../../../core/models/api.models';

export type ReplacementSelections = Record<number, number | null>;

export function isCorrectionBlocked(workspace: MetadataCorrectionWorkspace | undefined): boolean {
  return workspace?.hasInvestorPersonMappingConflicts ?? false;
}

export function canExecuteCorrection(
  preview: CorrectionPreview | undefined,
  executing: boolean,
  correctionBlocked: boolean,
  replacementSelections: ReplacementSelections
): boolean {
  if (!preview || executing || correctionBlocked) {
    return false;
  }

  if (!preview.requiresRelationshipReplacement) {
    return true;
  }

  return preview.replacementOptions.every(option =>
    replacementSelections[option.linkedInvestor.investorId] != null);
}

export function shouldSkipCorrectionPreview(
  investorId: number,
  previewLoading: boolean,
  previewInvestorId: number | undefined,
  preview: CorrectionPreview | undefined
): boolean {
  if (previewLoading && previewInvestorId === investorId) {
    return true;
  }

  return !previewLoading && preview?.investorIdToDelete === investorId;
}

export function buildCorrectionExecutionRequest(
  preview: CorrectionPreview,
  investorIdToDelete: number,
  virtualDeletedInvestorIds: number[],
  replacementSelections: ReplacementSelections
): CorrectionExecutionRequest {
  return {
    investorIdToDelete,
    virtualDeletedInvestorIds,
    replacementPlans: preview.replacementOptions.map(option => ({
      linkedInvestorId: option.linkedInvestor.investorId,
      replacementInvestorId: replacementSelections[option.linkedInvestor.investorId] as number
    }))
  };
}

export function getPreviewableCandidateInvestorId(candidate: {
  investor: Pick<ProblematicMetadataRow, 'investorId'>;
}): number {
  return candidate.investor.investorId;
}
